import styled from "styled-components";
import MapBackgroundImage from "../../../images/world_360_background.jpg";
import loginBackground from "../../../images/auto_background_img_left.svg";
import loginBackgroungNZ from "../../../images/nz_login_background.svg";
import loginBackgroungNZMobile from "../../../images/background_nz_phone.svg";
import loginBackgroungNZTablet from "../../../images/background_nz_tablet.svg";

export const LoginLayout=styled.main`
display: flex;
position: relative;
background-image: ${props=> props.isNZ ? `url(${loginBackgroungNZ})`: `url(${loginBackground})` };
width: 100%;
height: 100vh;
background-size: cover;
background-position: center center;
background-repeat: no-repeat;
background-attachment: fixed;
justify-content: ${props=> props.isNZ ? "flex-end" : "center" };
align-items: center;

.sub-login-container{
    position: absolute;
    text-align: left;
    background: rgba(0, 0, 0, 0.6);
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    padding: 20px; 
}
.ddContainer{
    display: none;
    margin-top: 5%;
}
.countryDD{
    border-radius: 5px;
    box-sizing: border-box;
    margin: auto;
    margin-top: 25px;
    width: 90%;
}
ul{
 margin-top: 27px;
 text-align: left;
 margin-left: 15px;
 list-style-type: none;
 padding-left: 0px !important;
 border:none;
}
li{
    display: inline;
    padding-right:25px;
}

.nav-item:hover, .nav-item button:hover{
    border:none;
    outline:0;
}
.nav-item button, .log-in-link a, .sign-up-link a{
    text-decoration: none;
    color:white !important;
    font-family: var(--font-family);
    font-style: normal;
    font-size: 18px;
    cursor: pointer;
    padding:0;
    border:none;
    outline:0;
}

.nav-item button.active, .selected-link{
    border:none;
    background:none;
    border-bottom:2px solid #F66700;
    padding-bottom: 3px;
}

.forgot-link{
    text-decoration: none;
    color:white;
    font-family: var(--font-family);
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    border-bottom: 1px solid #fff;
}
 .ddContainer img.logo{
//     width: 209px;
}


@media screen and (max-width: 740px){
    justify-content: center;
    background-image: ${props=> props.isNZMobile ? `url(${loginBackgroungNZMobile})`: `url(${loginBackground})` };
    background-position: 6% center;
    .login-container{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .ddContainer{
        display: none;
        border-bottom: solid 1px #fff;
        //padding: 50px 0;
        //margin-top: 100px;
    }
    
    .ddContainer img.logo{
        max-width: 50%;
        margin: 0 0 20px 0;
    }
    .ddContainer img{
        margin: 10px 0;
    }
    .countryDD{
        position: static;
        margin: 0 auto;
        width:75%;
        border: none;
        /* color:#FFFFFF */
    }

    .countryDD input.selectCountry{
        background: #FFFFFF;
        border: 1px solid #E6E6E6;
        border-radius: 32px;
        margin-bottom: 20px;
        width: 100%;
        height: 45px;
        padding: 10px;
    }
    .countryDD button{
        /* background: #FFFFFF; */
        border: 1px solid #E6E6E6;
        box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.15);
        border-radius: 10px;
        width: 100%;
        margin: 2%;
    }

    .countryDD .lastUsed {
        background: #FFFFFF;
        border: 1px solid #E6E6E6;        
        box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.15);
        border-radius: 10px;
        text-align: left;
    }
    .countryDD .lastUsed button{
        background: #FFFFFF;
        width: 90%;
        margin: 2%;
        box-shadow: none;
        border-radius: 0px;
        border: none;
        border-bottom: 1px solid #E6E6E6;
        text-align: left;
        padding:5px 10px
    }
    .countryDD button img{
        margin-right: 5px; 
        /* width: 27px;
        height: 17px; */
        
        /* changed for mobile screens */
        width: 22px;
        height: 12px;
    }

    .countryDD .prompt{
        font-weight: 600;
        font-size: 14px;
        line-height: 120%;
        text-align: justify;
        color: rgba(255, 255, 255, 0.8);
        padding:20px 0;
        border-top: 1px solid rgba(255, 255, 255, 0.3);
    }
    .countryDD h2{
        font-weight: 600;
        font-size: 28px;
        line-height: 120%;
        text-align: center;
        color: #FFFFFF;
        margin: 40px 0;
    }
    nav{
        margin-top: 27px;
        text-align: center;
    }
} 

@media screen and (max-width: 375px){
    .ddContainer{
        margin-top: 0;
    }
}
@media only screen and (min-width: 750px) and (max-width: 1199px) and (orientation: portrait) {
    justify-content: center;
    background-position: 9%;
    background-image: ${props=> props.isNZMobile ? `url(${loginBackgroungNZTablet})`: `url(${loginBackground})` };

    .ddContainer{
        padding: 10px 0;
        margin-top: 0px;
        border-bottom: none;
    }
}


@media only screen and (min-width: 750px) and (max-width: 1199px) and (orientation: landscape) { 
    justify-content: right;
    
    .ddContainer{
        padding: 10px 0;
        margin-top: 0px;
        border-bottom: none;
    }
}
`

export const LoginWrapper = styled.section`
// padding:20px 0 10px 0;
display:block;
@media screen and (max-width: 740px){
    &{
        width: 100%;
        flex-direction: column;
    }
} 
`;

export const SignUpWrapper = styled.section`
padding:30px 0;
//margin-bottom:24px;

.text-danger{
    --bs-text-opacity: 1;
    background: #C70000 !important;
    color: #fff !important;
    padding: 5px;
    position: relative;
    display:inline-block;
    width:90%;
}
@media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation:portrait) {
    //display: flex;
}

@media only screen and (min-device-width : 740px){
    #sign_up_text{
        display: none;
    }
}

@media screen and (max-width: 740px){
    &{
        display: block;
        text-align:center;
    }
    h2{
        font-size: 22px;
        line-height: 120%;
        text-align: center;
        color: #FFFFFF;
        margin-bottom:15px
    }
} 
`;

export const GetHelpWrapper = styled.section`
    position: absolute;
    width:auto;
    max-width: 250px;
    height: 43px;
    right: 2%;
    bottom: 2%;
    @media screen and (max-width: 740px){
        &{
            left:0;
            right:0;
            margin:0 auto;
            max-width: 150px;
        }
    } 
`;

export const MobileLogoWrapper = styled.section`
    margin: 105px 0 50px 0;
    text-align:center;
    img{
        width:184px;
        margin:0 auto;
    }
`;

export const LanguageSelectionButtonWrapper = styled.section`
    margin: 50px 0 105px 0;
    text-align:center;    
`;

export const MapWrapper = styled.div`
height:100vh;
background: radial-gradient(circle at 85.4% 50.8%, rgb(3, 6, 17) 0%, rgb(14, 72, 222) 74.2%);
background: url(${MapBackgroundImage}) no-repeat ;
background-size:100% 100%;
position: relative;

section{
    min-height:500px;
}
.ball {
    display: inline-block;
    width: 100%;
    height: 100%;
    margin: 0;
    border-radius: 50%;
    position: relative;
    transform-style: preserve-3d;
    -webkit-transform-style: preserve-3d;
    background-size: auto 100%;
    -webkit-animation: move-map 30s infinite linear;
    -moz-animation: move-map 30s infinite linear;
    -o-animation: move-map 30s infinite linear;
    -ms-animation: move-map 30s infinite linear;
    animation: move-map 30s infinite linear;
    overflow: hidden;
    box-shadow: 0 15px 8px 8px rgba(0,0,0,0.36);
  }
  
  .ball:before {
    content: "";
    position: absolute;
    top: 0%;
    left: 0%;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    box-shadow: -40px 10px 70px 10px rgba(0,0,0,0.5) inset;
    z-index: 2;
  }
  
  .ball:after {
    content: "";
    position: absolute; 
    border-radius: 50%;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    -webkit-filter: blur(0);
    filter: blur(0);
    opacity: 0;
    background: radial-gradient(circle at 50% 80%, #81e8f6, #76deef 10%, #055194 66%, #062745 100%);
  }
  
//   .stage .shadow {
//     position: absolute;
//     width: 75%;
//     height: 75%;
//     background: radial-gradient(circle at 50% 50%, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.1) 40%, rgba(0, 0, 0, 0) 50%);
//     transform: rotateX(90deg) translateZ(-150px);
//     border-radius: 50%;
//     left: 29%;
//     bottom: -15%;
//     background: #000;
//     opacity: 0.15;
//     transform: rotateZ(-38deg) skewX(28deg);
//     z-index: -1;
//   }

.stage .shadow{
    position: absolute;
    z-index: -1;
    left: 29%;
    bottom: -17%;
}
.stage .shadow .globe-shadow{
    height: 420px;
    opacity: 0.5;
}
  .stage {
    width: 500px;
    height: 500px;
    // display: inline-block;
    margin: 0px auto;
    padding:20px;
    -webkit-perspective: 1200px;
    -moz-perspective: 1200px;
    -ms-perspective: 1200px;
    -o-perspective: 1200px;
    perspective: 1200px;
    -webkit-perspective-origin: 50% 50%;
    -moz-perspective-origin: 50% 50%;
    -ms-perspective-origin: 50% 50%;
    -o-perspective-origin: 50% 50%;
    perspective-origin: 50% 50%;
  }

  .stage .gm-style{
     z-index:5 !important;
  }
`

export const MainWrapper = styled.main`
`

export const CommunityHeaderDayWrapper = styled.section`
    position: absolute;
    width: 100%;
    height: 77px;
    left: 0px;
    top: 0%;
    background: #688BAD;
    opacity: 0.66;

    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.3)); 
    div{
        position: absolute;
        width: 208.06px;
        height: 52.91px;
        left: 28px;
        top: 10px;
    } 
    input{
        box-sizing: border-box;

        /* Auto layout */

        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 8px 16px 9px 14px;
        gap: 8px;

        position: absolute;
        width: 300px;
        height: 38px;
        left: 75%;
        top: 19px;

        background: rgba(0, 0, 0, 0.2);
        border: 1px solid #F7F6F5;
        border-radius: 5px;
    }
    
`;

export const CommunityHeaderNiteWrapper = styled.section`
    position: absolute;
    width: 100%;
    height: 77px;
    left: 0px;
    top: 0%;
    background: #43688E;
    opacity: 0.66;

    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.3)); 
    div{
        position: absolute;
        width: 208.06px;
        height: 52.91px;
        left: 28px;
        top: 10px;
    } 
    input{
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 8px 16px 9px 14px;
        gap: 8px;
        position: absolute;
        width: 300px;
        height: 38px;
        left: 75%;
        top: 19px;
        background: rgba(0, 0, 0, 0.2);
        border: 1px solid #F7F6F5;
        border-radius: 5px;
    }
`;
